import React, { useState } from 'react'
import ClickAwayListener from 'react-click-away-listener'

//images
import dotsBlack from '../../../../../assets/images/pages/icons/dots-black.png'

function Material(props) {
    const each = props.material

    const [material, setMaterial] = useState({
        optionsMenu: false,
    })

    const handleMenuOptions = () => {
        setMaterial(material => ({
            ...material,
            optionsMenu: material.optionsMenu ? false : true
        }))
    }

    const handleClose = () => {
        if (material.optionsMenu) {
            setMaterial(material => ({
                ...material,
                optionsMenu: false
            }))
        }
    }

    const handleEdit = id => {
        props.handleEdit(id)
        handleClose()
    }

    return (
        <tr key={each.id}>
            <td>{each.type == 1? each.income_type.name : 'Склад'}</td>
            <td>{each.client ?  each.client.name : 'Връщане на материал'}</td>
            <td>{each.dmy}</td>
            <td className="income">{each.price} лв.</td>
            <td className="option">
                <img
                    src={dotsBlack}
                    alt="Опции"
                    title="Опции"
                    onClick={handleMenuOptions}
                />
                <ClickAwayListener onClickAway={handleClose}>
                    <div className={`options ${material.optionsMenu ? 'active' : ''}`}>
                        <div className="menu-item" onClick={() => handleEdit(each.id)}>
                            Редакция
                        </div>
                    </div>
                </ClickAwayListener>
            </td>
        </tr>
    )
}

export default Material